import { API_NAMES, initApi } from '@usas/ui-web/utils/HttpApiHelper';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const getClubBaseInfoData = (usasClubId, state, setState) => {
  const api = initApi(API_NAMES.CLUB, state, setState);

  const usasClubIdForUrl = usasClubId ? encodeURIComponent(usasClubId) : 'NaN';
  const url = `/UsasClub/${usasClubIdForUrl}/baseInfo`;

  return api.executeObject ? api.executeObject(url, 'GET') : null;
};

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const ClubBaseInfoData = {
  INITIAL_STATE,
  getClubBaseInfoData
};

export default ClubBaseInfoData;